/**
 * GC Countdown 0.1
 * Countdown in ES5 and no jQuery.
 */

/**
 * Main GcCountdown constructor
 *
 * @param {string} id Modal id (no hash needed)
 * @param {string} fromdate Starting date
 * @param {string} todate Ending date date
 */
function GcCountdown(options) {
  this.errors = [];
  if (!options.el || !this.setEl(options.el)) {
    this.setError('Não foi possível encontrar o timer');
    this.getErrors();
    return;
  }
  this.fromdate = options.fromdate;
  this.todate = options.todate;
  this.remaining = this.todate;

  if (options.timeEnd) {
    this.timeEnd = options.timeEnd;
  }

  this.elements = {
    daysSpan: this.el.querySelector('.days'),
    hoursSpan: this.el.querySelector('.hours'),
    minutesSpan: this.el.querySelector('.minutes'),
    secondsSpan: this.el.querySelector('.seconds')
  };

  this.updateClock();

  this.timer = setInterval(function () {
    this.updateClock();
  }.bind(this), 1000);
}

/**
 * Time ended default function
 */
GcCountdown.prototype.timeEnd = function () {};

/**
 * Set component element
 *
 * @param {string} id Modal id (no hash needed)
 */
GcCountdown.prototype.setEl = function (id) {
  this.el = document.getElementById(id);
  return this.el;
};

/**
 * Get an object with the amout of time remaining
 *
 * @param {string} fromdate Starting date for countdown
 * @param {string} remaining Amount of time remaining
 *
 * @return {object} Object with total, days, hours, minutes and seconds of the remaining time
 */
GcCountdown.prototype.getTimeRemaining = function (fromdate, remaining) {
  var t = remaining - fromdate;
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor((t / (1000 * 60 * 60 * 24)));
  var timeRemaining = {
    total: t,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
  return timeRemaining;
};

/**
 * Tick one second less in the reamining time
 *
 * @return {string} Remaining time
 */
GcCountdown.prototype.tick = function () {
  this.remaining -= 1000;
  return this.remaining;
};

/**
 * Update the clockdown visually
 *
 * @return void
 */
GcCountdown.prototype.updateClock = function () {
  this.tick();

  var t = this.getTimeRemaining(this.fromdate, this.remaining);

  try {
    if (this.elements.daysSpan) {
      this.elements.daysSpan.innerHTML = ('0' + t.days).slice(-2);
    }
    if (this.elements.hoursSpan) {
      this.elements.hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    }
    if (this.elements.minutesSpan) {
      this.elements.minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    }
    if (this.elements.secondsSpan) {
      this.elements.secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
    }
  } catch (e) {
    this.setError('Erro ao inserir data no HTML ' + e);
  }

  if (t.total <= 0) {
    this.timeEnd();
    clearInterval(this.timer);
  }
};

/**
 * Push an error to the errors list
 *
 * @return void
 */
GcCountdown.prototype.setError = function (error) {
  this.errors.push(error);
};

/**
 * Output to the console every error registred in the erros array
 */
GcCountdown.prototype.getErrors = function () {
  // eslint-disable-next-line no-console
  console.error(this.errors);
};
